import React, { ReactNode } from 'react';
import { TextMedium16, TextMedium14 } from '@/app/components/texts';
import { t } from 'i18next';
import styles from '../styles.module.scss';

interface ProfileFieldProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

/**
 * A reusable component for profile form fields with consistent styling
 */
const ProfileField: React.FC<ProfileFieldProps> = ({
  title,
  description,
  children,
  className,
}) => {
  return (
    <div className={`${styles.block} ${className || ''}`}>
      <TextMedium16 text={t(title)} className={styles.title} />
      {description && (
        <TextMedium14 text={t(description)} className={styles.text} />
      )}
      {children}
    </div>
  );
};

export default ProfileField;